export enum DropdownFilterType {
    All,
    Blank,
    NonBlank,
    ByValue,
    None,
    DateRange
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/interfaces/dropdown-filter-type.ts